<template>
  <div :class="['marker', { 'marker--good': good }]">
    <span>
      <slot />
    </span>

    <img
      v-if="good"
      class="marker__tail"
      src="../assets/img/power-tail-good.svg"
    />
    <img v-else class="marker__tail" src="../assets/img/power-tail.svg" />
  </div>
</template>

<script>
export default {
  props: ["good"]
};
</script>

<style lang="scss" scoped>
.marker {
  position: relative;

  display: grid;

  padding: 2px 10px;

  border-radius: 3px;
  font-size: 12px;
  font-weight: 500;

  padding-bottom: 3px;

  color: $white;
  background-color: $primary;
  border: 1px solid #ff8fd2;
  box-shadow: 3px 0px 0px -1px $primary, 3px 0px 0px #ff8fd2;

  &__tail {
    position: absolute;
    bottom: 0;
    transform: translate(3px, 6px);
    justify-self: center;
  }

  &--good {
    color: $dark_blue;
    background-color: $white;
    border: 1px solid $dark_blue;
    box-shadow: -3px 0px 0px -1px $white, -3px 0px 0px $dark_blue;

    .marker__tail {
      transform: translate(-3px, 6px);
    }
  }
}
</style>
